<!-- 经销商走访 -->
<script setup>
import { computed, onMounted, reactive, ref, watch } from "vue";
import http from "@/utils/http";
import { Dialog } from "vant";
import throttle from "lodash/throttle";

const localDraftKey = "QUESTIONNAIRE:DISTRIBUTOR:DRAFT";

const yesOrNoOptions = [
  { label: "是", value: "1" },
  { label: "否", value: "0" },
];
const operationOptions = [
  { label: "0分：没做过", value: "0" },
  { label: "1分：经销商不清楚怎么做", value: "1" },
  { label: "2分：介于1-3分之间", value: "2" },
  { label: "3分：经销商基本知道怎么做", value: "3" },
  { label: "4分：介于3-5分之间", value: "4" },
  { label: "5分：经销商运作出色", value: "5" },
];
const maintenanceOptions = [
  { label: "不太重视", value: "0" },
  { label: "1分：经销商不清楚怎么做", value: "1" },
  { label: "2分：介于1-3分之间", value: "2" },
  { label: "3分：定期维护", value: "3" },
  { label: "4分：介于3-5分之间", value: "4" },
  { label: "5分：经销商运作出色", value: "5" },
];
const proficiencyOptions = [
  { label: "1分：基本无法运用", value: "1" },
  { label: "2分：部分可用", value: "2" },
  { label: "3分：基本可运用", value: "3" },
  { label: "4分：大多数可运用", value: "4" },
  { label: "5分：大家都熟练掌握", value: "5" },
];

const questionnaireTitle = "《经典事业部-区域巡店调研问卷》";
const questions = ref([
  {
    id: 0,
    title: "基础信息",
    children: [
      {
        id: "userName",
        label: "真实姓名：",
        value: "",
        required: true,
      },
      {
        id: "userAccount",
        label: "员工编号：",
        value: "",
        required: true,
      },
      {
        id: "dealerName",
        label: "授权城市-实控人：",
        value: "",
        required: true,
        readonly: true,
      },
      {
        id: "dealerCode",
        label: "经销商编号：",
        value: "",
        required: true,
        readonly: true,
      },
      {
        id: "noDerucci",
        label: "经销商是否有代理其他非慕思品牌",
        value: "",
        required: true,
        options: yesOrNoOptions,
      },
      {
        id: "brandRemark",
        label: "代理的其他非慕思品牌：",
        value: "",
        required: true,
        show: computed(() => questions.value[0].children[4].value === "1"),
      },
      {
        id: "timelyReload",
        label: "所授权城市门店到期是否按时重装",
        value: "",
        required: true,
        options: yesOrNoOptions,
      },
      {
        id: "areaStandard",
        label: "所授权城市门店面积是否达标",
        value: "",
        required: true,
        options: yesOrNoOptions,
      },
    ],
  },
  {
    id: 1,
    title: "引流",
    children: [
      {
        id: 8,
        label:
          "您评估经销商整体做O2O引流的能力如何（1-5分）可结合其有效客资、转化率、相关业绩",
        value: "",
        required: true,
        options: operationOptions,
      },
      {
        id: 9,
        label:
          "您评估经销商整体做同城直播/短视频的能力如何（1-5分）可结合其有效客资、转化率、相关业绩",
        value: "",
        required: true,
        options: operationOptions,
      },
      {
        id: 10,
        label:
          "您评估经销商自行做线上投放引流的能力如何（1-5分）可结合其有效客资、转化率、相关业绩",
        value: "",
        required: true,
        options: operationOptions,
      },
      {
        id: 11,
        label:
          "您评估经销商整体做异业联盟的能力如何（1-5分）可结合其有效客资、转化率、相关业绩",
        value: "",
        required: true,
        options: operationOptions,
      },
      {
        id: 12,
        label:
          "您评估经销商整体做扫楼的能力如何（1-5分）可结合其有效客资、转化率、相关业绩?",
        value: "",
        required: true,
        options: operationOptions,
      },
      {
        id: 13,
        label:
          "您评估经销商整体做老客户转介的能力如何（1-5分）可结合其有效客资、转化率、相关业绩",
        value: "",
        required: true,
        options: operationOptions,
      },
      {
        id: 14,
        label:
          "请用简短的语句，评价该经销商的整体引流水平，评价需要有标准、有依据",
        value: "",
        required: true,
      },
    ],
  },
  {
    id: 2,
    title: "转化x客单 店面环境",
    children: [
      {
        id: 15,
        label:
          "为匹配慕思品牌中高端定位，您觉得当前经销商在门店装修设计、摆场陈列和动线设计做得如何？",
        value: "",
        required: true,
        options: maintenanceOptions,
      },
      {
        id: 16,
        label:
          "为匹配慕思品牌中高端定位，您觉得您当前经销商在门店环境维护、导购员形象管理做得如何？",
        value: "",
        required: true,
        options: maintenanceOptions,
      },
      {
        id: 17,
        label:
          "请用简短的语句，评价该经销商的整体店面环境管理水平，评价需要有标准、有依据",
        value: "",
        required: true,
      },
    ],
  },
  {
    id: 3,
    title: "转化x客单 选品能力",
    children: [
      {
        id: 18,
        label:
          "您认为经销商门店选品能力如何（根据当地市场特点进行因地制宜选品，根据公司标准，考虑销售情况、价位段、睡感等维度进行新品上样）",
        value: "",
        required: true,
        options: operationOptions,
      },
      {
        id: 19,
        label:
          "请用简短的语句，评价该经销商的整体选品能力水平，评价需要有标准、有依据",
        value: "",
        required: true,
      },
    ],
  },
  {
    id: 4,
    title: "转化x客单 基本功",
    children: [
      {
        id: 20,
        label: "您评估经销商门店导购对品牌与健康知识掌握和运用能力如何？",
        value: "",
        required: true,
        options: proficiencyOptions,
      },
      {
        id: 21,
        label:
          "您评估经销商门店导购对核心材质、战略产品知识掌握和运用能力如何？",
        value: "",
        required: true,
        options: proficiencyOptions,
      },
      {
        id: 22,
        label:
          "您评估经销商门店导购对六大基本九步销售流程、体验流程掌握和运用能力如何？",
        value: "",
        required: true,
        options: proficiencyOptions,
      },
      {
        id: 23,
        label:
          "请用简短的语句，评价该经销商的整体基本功水平，评价需要有标准、有依据",
        value: "",
        required: true,
      },
    ],
  },
  {
    id: 5,
    title: "转化x客单 推套餐",
    children: [
      {
        id: 24,
        label: "请您对经销商门店导购卖多卧的能力打分 ，可结合其多卧搭售率",
        value: "",
        required: true,
        options: operationOptions,
      },
      {
        id: 25,
        label: "多卧搭售率为___（%）",
        value: "",
        kbType: "number",
        min: 0,
        max: 100,
        required: true,
      },
      {
        id: 26,
        label: "请您对经销商门店导购搭售套床的能力打分，可结合其套床搭售率",
        value: "",
        required: true,
        options: operationOptions,
      },
      {
        id: 27,
        label: "套床搭售率为___（%）",
        value: "",
        kbType: "number",
        min: 0,
        max: 100,
        required: true,
      },
      {
        id: 28,
        label: "请您对经销商门店导购搭售配套品的能力打分，可结合其配套品搭售率",
        value: "",
        required: true,
        options: operationOptions,
      },
      {
        id: 29,
        label: "配套品搭售率为___（%）",
        value: "",
        kbType: "number",
        min: 0,
        max: 100,
        required: true,
      },
      {
        id: 30,
        label: "近半年经销商门店订单平均客单值为___（元）",
        value: "",
        kbType: "number",
        required: true,
      },
      {
        id: 31,
        label:
          "请用简短的语句，评价该经销商的整体推套餐水平，评价需要有标准、有依据",
        value: "",
        required: true,
      },
    ],
  },
  {
    id: 6,
    title: "售后服务",
    children: [
      {
        id: 32,
        label: "您评估经销商门店整体做金管家(售后)服务的能力如何（1-5分）",
        value: "",
        required: true,
        options: operationOptions,
      },
      {
        id: 33,
        label:
          "请用简短的语句，评价该经销商的整体金管家（售后）服务水平，评价需要有标准、有依据",
        value: "",
        required: true,
      },
    ],
  },
  {
    id: 7,
    title: "主动营销",
    children: [
      {
        id: 34,
        label: "您评估经销商门店整体做IP活动落地的能力如何（1-5分）",
        value: "",
        required: true,
        options: operationOptions,
      },
      {
        id: 35,
        label: "如做过，经销商门店IP活动销售规模___（元）",
        value: "",
        kbType: "number",
        required: true,
      },
      {
        id: 36,
        label: "您评估经销商门店整体做潜客蓄水邀约的能力如何",
        value: "",
        required: true,
        options: operationOptions,
      },
      {
        id: 37,
        label: "您评估经销商门店整体做潜客集中爆破的能力如何",
        value: "",
        required: true,
        options: operationOptions,
      },
      {
        id: 38,
        label: "如做过，经销商门店集中爆破单场次销售规模___（元）",
        value: "",
        kbType: "number",
        required: true,
      },
      {
        id: 39,
        label: "您评估经销商门店整体做社区团购的能力如何（1-5分）",
        value: "",
        required: true,
        options: operationOptions,
      },
      {
        id: 40,
        label: "如做过，经销商社区团购占月均营业额的比例为___% ",
        value: "",
        kbType: "number",
        min: 0,
        max: 100,
        required: true,
      },
      {
        id: 41,
        label: "您评估经销商门店整体做非销活动的能力如何（1-5分）",
        value: "",
        required: true,
        options: operationOptions,
      },
      {
        id: 42,
        label: "您评估经销商门店整体做当地明星活动的能力如何（1-5分）",
        value: "",
        required: true,
        options: operationOptions,
      },
      {
        id: 43,
        label: "如做过，经销商门店当地明星活动销售规模___（元）",
        value: "",
        kbType: "number",
        required: true,
      },
      {
        id: 44,
        label: "您评估经销商门店整体做社群营销的能力如何（1-5分）",
        value: "",
        required: true,
        options: operationOptions,
      },
      {
        id: 45,
        label: "如做过，经销商社群营销占月均营业额的比例为___% ",
        value: "",
        kbType: "number",
        min: 0,
        max: 100,
        required: true,
      },
      {
        id: 46,
        label:
          "请用简短的语句，评价该经销商的整体主动营销水平，评价需要有标准、有依据",
        value: "",
        required: true,
      },
    ],
  },
  {
    id: 8,
    title: "装企运营与开拓",
    children: [
      {
        id: 47,
        label: "您评估经销商门店整体做装企开拓与运营的能力如何（1-5分）",
        value: "",
        required: true,
        options: operationOptions,
      },
      {
        id: 48,
        label: "如做过，目前装企渠道占总月均营业额的比例为___% ",
        value: "",
        kbType: "number",
        min: 0,
        max: 100,
        required: true,
      },
      {
        id: 49,
        label: "如做过，装企数量为__家",
        value: "",
        kbType: "number",
        required: true,
      },
      {
        id: 50,
        label:
          "请用简短的语句，评价该经销商的整体装企运营与开拓水平，评价需要有标准、有依据",
        value: "",
        required: true,
      },
    ],
  },
  {
    id: 9,
    title: "门店管理",
    children: [
      {
        id: 51,
        label:
          "对于经销商现在目标与会议管理运作的状态评分，可结合其业绩目标达成率",
        value: "",
        required: true,
        options: [
          { label: " 不太关注", value: "0" },
          { label: " 1分：会议机制不完善，无法有效追踪门店目标", value: "1" },
          { label: " 2分：介于1-3分之间", value: "2" },
          {
            label: " 3分：会议机制基本健全，能形成监控力量，但复盘与改善不足",
            value: "3",
          },
          { label: " 4分：介于3-5分之间", value: "4" },
          {
            label: " 5分：会议机制运行成熟，促进门店人员持续进步、达成目标",
            value: "5",
          },
        ],
      },
      {
        id: 52,
        label: "当前经销商导购考核激励机制能否有效激励导购达成目标？",
        value: "",
        required: true,
        options: operationOptions,
      },
      {
        id: 53,
        label: "经销商门店对4S管理的掌握程度如何？（1-5分），可参考4S评分体系",
        value: "",
        required: true,
        options: operationOptions,
      },
      {
        id: 54,
        label:
          "请用简短的语句，评价该经销商的整体门店管理水平，评价需要有标准、有依据",
        value: "",
        required: true,
      },
    ],
  },
  {
    id: 10,
    title: "公司化运营",
    children: [
      {
        id: 55,
        label: "请对您经销商业务规划与经营管理能力进行评价",
        value: "",
        required: true,
        options: operationOptions,
      },
      {
        id: 56,
        label: "请对您经销商客户关系管理能力进行评价，可结合其",
        value: "",
        required: true,
        options: operationOptions,
      },
      {
        id: 57,
        label: "请对您经销商进销存管理能力进行评价，可参考其库存周转情况",
        value: "",
        required: true,
        options: operationOptions,
      },
      {
        id: 58,
        label:
          "请对您经销商人力资源管理能力进行评价，可参考其组织架构与岗位编制完整性和合理性",
        value: "",
        required: true,
        options: operationOptions,
      },
      {
        id: 59,
        label: "请对您经销商财务管理能力进行评价",
        value: "",
        required: true,
        options: operationOptions,
      },
      {
        id: 60,
        label:
          "请用简短的语句，评价该经销商的整体公司化运营水平，评价需要有标准、有依据",
        value: "",
        required: true,
      },
    ],
  },
]);
initDraft();
watch(
  questions,
  throttle((v) => saveDraft(v), 10 * 1000, {
    leading: false,
  }),
  {
    deep: true,
  }
);

const submitting = ref(false);
const submitted = ref(false);
async function onSubmit() {
  try {
    if (submitting.value) return;
    submitting.value = true;
    const payload = {};
    const infos = questions.value[0].children;
    infos.forEach((info) => {
      if (info.options) {
        payload[info.id] = Number(info.value);
      } else {
        payload[info.id] = info.value;
      }
    });
    payload.personalExaminationResults = questions.value
      .slice(1)
      .map((v) =>
        v.children.map((child) => {
          const result = {
            typeId: v.id,
            typeName: v.title,
            questionId: child.id,
            question: child.label,
          };
          if (!child.options) {
            result.answer = child.value;
          } else {
            result.answer = child.options.find(
              (option) => option.value === child.value
            ).label;
            result.score = Number(child.value);
          }
          return result;
        })
      )
      .flat();
    await addQuestionnaire(payload);
    submitted.value = true;
    removeDraft();
    await Dialog({
      message: "提交成功",
    });
  } catch (err) {
    Dialog({
      message: err.msg || err.message,
    });
  } finally {
    submitting.value = false;
  }
}
function onFailed({ errors }) {
  const firstError = errors[0];
  const el = [...document.querySelectorAll(".form-item-label")].find((el) =>
    el.innerHTML.includes(firstError.name)
  );
  el.scrollIntoViewIfNeeded();
}

async function addQuestionnaire(data) {
  const res = await http.post("/dealermanage/app/examinationresult/add", data);
  return res;
}

function convertNumber(v, options = {}) {
  const { positive, min, max } = options;
  if (v === "") {
    return null;
  }
  const converted = Number(v);
  if (isNaN(converted)) {
    return null;
  }
  const abs = positive ? Math.abs(converted) : converted;
  if (min != undefined && abs < min) {
    return min;
  }
  if (max != undefined && abs > max) {
    return max;
  }
  return abs;
}

function onFieldClick(question) {
  if (question.id === "dealerCode" || question.id === "dealerName") {
    dealerPicker.opened = true;
  }
}

const dealerPicker = reactive({
  opened: false,
  search: "",
  items: [],
});
onMounted(fetchDealers);
function onDealerSearch() {
  fetchDealers();
}
function onDealerConfirm(evt) {
  const dealerCodeItem = questions.value[0].children.find(
    (v) => v.id === "dealerCode"
  );
  dealerCodeItem.value = evt.value;
  const dealerNameItem = questions.value[0].children.find(
    (v) => v.id === "dealerName"
  );
  dealerNameItem.value = evt.name;
  dealerPicker.opened = false;
}
async function fetchDealers() {
  const query = {
    currPage: 1,
    pageSize: 100,
    dealerName: "",
    dealerCode: "",
  };
  const isDigit = /\d/g.test(dealerPicker.search);
  if (isDigit) {
    query.dealerCode = dealerPicker.search;
  } else {
    query.dealerName = dealerPicker.search;
  }
  const res = await http.get("/dealermanage/crmdistributor/listpage", query);
  dealerPicker.items = res.data.map(({ dealerName, dealerCode }) => ({
    label: `${dealerName}（${dealerCode}）`,
    name: dealerName,
    value: dealerCode,
  }));
}

function saveDraft(v) {
  const data = {};
  v.forEach(({ children }) => {
    children.forEach((child) => {
      if (child.value === "" || child.value == undefined) return;
      data[child.label] = child.value;
    });
  });
  const json = JSON.stringify(data);
  localStorage.setItem(localDraftKey, json);
}
function removeDraft() {
  localStorage.removeItem(localDraftKey);
}
function initDraft() {
  const json = localStorage.getItem(localDraftKey);
  if (!json) return;
  const draft = JSON.parse(json);
  questions.value.forEach(({ children }) => {
    children.forEach((child) => {
      if (draft[child.label] == undefined) return;
      child.value = draft[child.label];
    });
  });
}
</script>

<template>
  <div class="page">
    <div class="title">{{ questionnaireTitle }}</div>
    <van-form
      class="form"
      :disabled="submitted"
      @submit="onSubmit"
      @failed="onFailed"
    >
      <div class="form-group" v-for="group in questions" :key="group.title">
        <div class="form-group-title">
          <span>
            {{ group.title }}
          </span>
          <span class="form-group-indicator">{{
            `${group.children.filter((v) => v.value !== "").length}/${
              group.children.filter((v) => v.show !== false).length
            }`
          }}</span>
        </div>
        <div
          class="form-item"
          v-for="(question, idx) in group.children.filter(
            (v) => v.show !== false
          )"
          :key="question.label"
        >
          <div class="form-item-label">
            {{ `${idx + 1}. ${question.label}` }}
          </div>
          <van-field
            :name="question.label"
            label=""
            v-model="question.value"
            :rules="[{ required: question.required, message: '该项为必填项' }]"
          >
            <template #input>
              <van-radio-group
                v-if="question.options"
                :disabled="submitted"
                v-model="question.value"
              >
                <van-radio
                  class="form-field--radio"
                  v-for="option in question.options"
                  :key="option.value"
                  :name="option.value"
                  >{{ option.label }}</van-radio
                >
              </van-radio-group>
              <van-field
                v-else
                class="form-field--input"
                :placeholder="questions.placeholder"
                v-model="question.value"
                :type="question.kbType"
                clearable
                :readonly="question.readonly"
                @click="onFieldClick(question)"
                @change="
                  (evt) => {
                    const trimmed = evt.target.value.trim();
                    if (question.kbType === 'number') {
                      question.value = convertNumber(trimmed, {
                        positive: true,
                        min: question.min,
                        max: question.max,
                      });
                    } else {
                      question.value = trimmed;
                    }
                  }
                "
              />
            </template>
          </van-field>
        </div>
      </div>
      <div class="form-submit">
        <van-button
          :loading="submitting"
          :disabled="submitted"
          type="info"
          native-type="submit"
          block
          >{{ submitted ? "已提交" : "提交" }}</van-button
        >
      </div>
    </van-form>
    <van-popup v-model="dealerPicker.opened" round position="bottom">
      <van-search
        v-model="dealerPicker.search"
        show-action
        placeholder="输入名称或编号搜索"
        clear-trigger="always"
        @search="onDealerSearch"
      >
        <template #action>
          <div @click="onDealerSearch">搜索</div>
        </template>
      </van-search>
      <van-picker
        show-toolbar
        :columns="dealerPicker.items"
        @cancel="dealerPicker.opened = false"
        @confirm="onDealerConfirm"
        value-key="label"
      />
    </van-popup>
  </div>
</template>

<style lang="scss" scoped>
.page {
  font-size: 16px;
  background: #f8f8f8;
  padding-bottom: 16px;
  padding-bottom: calc(constant(safe-area-inset-bottom) + 16px);
  padding-bottom: calc(env(safe-area-inset-bottom) + 16px);
  line-height: 1.5;
}
.form {
  &-group {
    background: #fff;
    border: 1px solid #eee;
    border-width: 1px 0;
    padding: 0 16px;
    &:not(:last-child) {
      margin-bottom: 8px;
    }
    &-title {
      position: sticky;
      z-index: 1;
      top: 0;
      font-size: 16px;
      text-align: center;
      padding: 16px 0;
      border-bottom: 1px solid #e3e3e3;
      background: #fff;
      margin-bottom: 16px;
      color: #1989fa;
    }
    &-indicator {
      color: #aaa;
      font-size: 12px;
    }
  }
  &-item {
    position: relative;
    margin-bottom: 20px;
    &::before {
      position: absolute;
      z-index: 1;
      top: 0;
      left: -8px;
      content: "*";
      color: rgb(228, 28, 14);
    }
    &-label {
      color: #888;
    }
  }
  &-field {
    &--input {
      border: 1px solid #eee;
    }
    &--radio {
      margin-bottom: 8px;
    }
  }
  &-submit {
    margin: 16px;
    margin-bottom: 0;
  }
}
.title {
  font-size: 20px;
  text-align: center;
  padding: 32px 0;
  font-weight: bold;
  color: rgb(228, 158, 8);
}
</style>
